module.exports = __webpack_public_path__ + "img/support.fe9b4cce.png";